define('GameDayCore/GDControl/advertising/PageVisibilityManager',['require','exports','module','../../GDModel/enums/events/EventTypes','message-service/message-service','../../GDUtil/window/Logg'],function(require,exports,module) {
    // Set the name of the "hidden" property and the change event for visibility
    var EventTypes = require("../../GDModel/enums/events/EventTypes"),
        MessageService = require("message-service/message-service"),
        logg = require("../../GDUtil/window/Logg"),
        pageIsVisible = true, 
        hidden, 
        visibilityChange;

    if (typeof document.hidden !== "undefined") {
      hidden = "hidden";
      visibilityChange = "visibilitychange";
    } else if (typeof document.mozHidden !== "undefined") { // Firefox up to v17
      hidden = "mozHidden";
      visibilityChange = "mozvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") { // Chrome up to v32, Android up to v4.4, Blackberry up to v10
      hidden = "webkitHidden";
      visibilityChange = "webkitvisibilitychange";
    }
    
    var videoElement = document.getElementById("videoElement");

    // If the page is hidden, pause the video;
    // if the page is shown, play the video
    function handleVisibilityChange() {
      if (document[hidden]) {
        logg.log("PageVisibilityManager : handleVisibilityChange : hidden");
    	  pageIsVisible = false;
          MessageService.publish(EventTypes.PAGE_VISIBILITY_CHANGED);
      } else {
        logg.log("PageVisibilityManager : handleVisibilityChange : visible");
    	  pageIsVisible = true;
          MessageService.publish(EventTypes.PAGE_VISIBILITY_CHANGED);
      }
    }

    // Warn if the browser doesn't support addEventListener or the Page Visibility API
    if (typeof document.addEventListener === "undefined" || typeof document[hidden] === "undefined") {
      logg.log("PageVisibilityManager : Page Visibility API not supported by this browser.");
    } else {
      // Handle page visibility change   
      document.addEventListener(visibilityChange, handleVisibilityChange, false);
    }


    exports.getPageVisibility = function(){
        return pageIsVisible;
    }
});
